import { useMutation, UseMutationOptions } from 'react-query';
import { AxiosError } from "axios";

import request from "common/request";

// type KakaopayRegistrationMutationVariable = {};

export const usePostKakaopay = ( 
  options?: UseMutationOptions<any, AxiosError>
) => { 
  return useMutation<any, AxiosError>(
    async () => {
      try {
        const response = await request.post('/kakao/test');
        
        return response
      } catch(e){
        //@ts-ignore
        const result = e.response;
        return result
      }
    },
    {
      ...options
    }
  )
};

export default usePostKakaopay;